module.exports = __webpack_public_path__ + "img/green.be5030ca.webp";